// extracted by mini-css-extract-plugin
export var benefits = "BenefitList-module--benefits--1L658";
export var servicesBenefits = "BenefitList-module--servicesBenefits--2k0MC";
export var item = "BenefitList-module--item--34CnV";
export var title = "BenefitList-module--title--27F00";
export var circle = "BenefitList-module--circle--2whe_";
export var outer = "BenefitList-module--outer--JY_LQ";
export var section = "BenefitList-module--section--1uES-";